import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ToastMsg from "../../components/common/ToastMsg";
import { ImagePaths } from "../../utils/ImagePaths";
import { emailValidation } from "../../components/common/CommonFunctions";
import { SEND_OTP } from "../../constants/api";
import useApiMethods from "../../lib/useApiMethods";
import { Input } from "../../components/ui/input";
import { AuthSubmitButton, FormLabel } from "../../components/ui/form-fields";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { create } = useApiMethods();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onFinish = async (e) => {
    e.preventDefault();

    if (!email) {
      ToastMsg("error", "Registered email is required");
      return;
    }
    if (!emailValidation(null, email)) {
      ToastMsg("error", "Please enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const payload = { email };

      const response = await create(SEND_OTP, payload, false, setLoading, token);

      if (response?.status === "success") {
        ToastMsg("success", response.message || "OTP sent successfully");
        navigate("/otpverification", {
          state: { id: response.user_id, email },
        });
      } else {
        ToastMsg("error", response.message || "Something went wrong");
      }
    } catch (error) {
      ToastMsg("error", error.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center relative bg-background font-sans">
      <div
        className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/2162167863/photo/businessman-in-the-logging-in-using-a-secure-web-page.jpg?s=1024x1024&w=is&k=20&c=Hc1J9SSw49Ekb4iTLfUJd-vL_Cicbl3WMlABp4yBLSE=')] bg-cover bg-center opacity-20"
      />
      <div className="absolute inset-0 bg-white/40 dark:bg-black/40 backdrop-blur-sm" />

      <div className="w-full max-w-sm relative z-10">
        <div className="flex justify-center mb-6">
          <img
            src={ImagePaths.loginLogo}
            alt="App Logo"
            className="h-10 w-auto animate-fadeIn"
          />
        </div>

        <div className="bg-card/95 backdrop-blur-md rounded-xl shadow-xl p-6 animate-fadeIn border border-border">
          <div className="flex items-center mb-4">
            <img
              src={ImagePaths.backArrow}
              alt="Back"
              className="h-5 w-5 cursor-pointer mr-2"
              onClick={() => navigate("/")}
            />
            <h2 className="text-lg font-semibold text-foreground">
              Forgot Password
            </h2>
          </div>

          <p className="text-sm text-muted-foreground mb-5">
            Enter your registered email ID to receive an OTP.
          </p>

          <form onSubmit={onFinish} className="space-y-4">
            <div className="space-y-1.5">
              <FormLabel htmlFor="email">Email Address</FormLabel>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your registered email"
              />
            </div>

            <AuthSubmitButton loading={loading} loadingText="Sending OTP...">
              Send OTP
            </AuthSubmitButton>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
